/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomAttributeDistributionNumeric
 */
export interface CustomAttributeDistributionNumeric {
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomAttributeDistributionNumeric
     */
    binHeights: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomAttributeDistributionNumeric
     */
    binEdges: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CustomAttributeDistributionNumeric
     */
    valueMin: number;
    /**
     * 
     * @type {number}
     * @memberof CustomAttributeDistributionNumeric
     */
    valueMax: number;
}

export function CustomAttributeDistributionNumericFromJSON(json: any): CustomAttributeDistributionNumeric {
    return CustomAttributeDistributionNumericFromJSONTyped(json, false);
}

export function CustomAttributeDistributionNumericFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAttributeDistributionNumeric {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'binHeights': json['binHeights'],
        'binEdges': json['binEdges'],
        'valueMin': json['valueMin'],
        'valueMax': json['valueMax'],
    };
}

export function CustomAttributeDistributionNumericToJSON(value?: CustomAttributeDistributionNumeric | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'binHeights': value.binHeights,
        'binEdges': value.binEdges,
        'valueMin': value.valueMin,
        'valueMax': value.valueMax,
    };
}


